export const FETCH_COMMUNICATION_METHODS_REQUEST = "FETCH_COMMUNICATION_METHODS_REQUEST";
